import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "messages", "submit"]

  connect() {
    if (this.hasMessagesTarget) {
      this.scrollToBottom()
    }
    this.isRequestInProgress = false
    this.toggleSubmitButton()
  }

  toggleSubmitButton() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = this.isRequestInProgress || !this.inputTarget.value.trim()
    }
  }

  toggleFormDisabled(disabled) {
    this.inputTarget.disabled = disabled
    this.submitTarget.disabled = disabled
  }

  inputChanged() {
    this.toggleSubmitButton()
  }

  close(event) {
    event.preventDefault()
    this.element.remove()
  }

  send(event) {
    event.preventDefault()

    const input = this.inputTarget
    const message = input.value.trim()

    if (!message) return

    // Form
    const form = event.target
    const formData = new FormData(form)

    // Mark that there is a request in progress
    this.isRequestInProgress = true
    this.submitTarget.disabled = true

    // Unique ID for the user's temporary message
    const tempId = `user-message-temp-${Date.now()}`
    this.appendMessage(message, 'user', false, tempId)

    // Clear input immediately after sending
    input.value = ''
    this.toggleSubmitButton()

    // Loader
    const loaderId = 'loading-message'
    this.appendMessage(`
      <div class="flex items-center space-x-2">
        <div class="animate-spin h-5 w-5 border-2 border-indigo-500 border-t-transparent rounded-full"></div>
        <span class="text-gray-500">Thinking...</span>
      </div>
    `, 'assistant', false, loaderId)
    this.scrollToBottom()

    fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    }).then(async response => {
      if (!response.ok) throw new Error('There was an error processing your message.')

      // Manually process the Turbo Stream response
      const html = await response.text()

      const template = document.createElement('template')
      template.innerHTML = html
      document.body.appendChild(template.content)

      // Only remove the loader after processing the Turbo Stream
      const loader = document.getElementById(loaderId)
      if (loader) loader.remove()

      // Wait for Turbo to finish processing the actions
      requestAnimationFrame(() => {
        this.scrollToBottom()
      })
    }).catch(error => {
      const loader = document.getElementById(loaderId)
      if (loader) loader.remove()
      this.appendMessage('Sorry, there was an error processing your message. Please try again.', 'assistant', true)
      this.scrollToBottom()
    }).finally(() => {
      // Marcar que la petición ha terminado
      this.isRequestInProgress = false
      this.toggleSubmitButton()
    })
  }

  appendMessage(content, role, isError = false, id = null) {
    // Always append the message inside #chat_messages
    const messagesContainer = document.getElementById('chat_messages');
    if (!messagesContainer) {
      return;
    }

    const messageDiv = document.createElement('div');
    messageDiv.className = `ai-chat-message ${role === 'user' ? 'text-right' : 'text-left'}`;
    if (id) messageDiv.id = id;
    const bubble = document.createElement('span');
    bubble.className = `ai-chat-bubble ${role === 'user' ? 'ai-chat-bubble--user' : 'ai-chat-bubble--assistant'} max-w-[80%] prose prose-base`;
    if (isError) bubble.classList.add('text-red-500');
    bubble.innerHTML = content;
    messageDiv.appendChild(bubble);
    messagesContainer.appendChild(messageDiv);
  }

  scrollToBottom() {
    if (!this.hasMessagesTarget) {
      return
    }
    const messagesContainer = this.messagesTarget
    messagesContainer.scrollTop = messagesContainer.scrollHeight
  }

  handleBack(event) {
    event.preventDefault()

    if (window.history.length > 1) {
      window.history.back()
    } else {
      window.location.href = '/'
    }
  }
}
